import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import CtaButton from 'components/essentials/Cta/CtaButton';
import Link from 'components/consumer/Link';
import JBImage from 'components/essentials/JBImage';
import JBIFrameHolder from 'components/essentials/JBIFrameHolder';
import FinancingCtaButton from 'components/essentials/FinancingCtaButton';
const ToggleCTAImageLink = props => {
  const $ = _c(36);
  const {
    imageProps,
    toggleInputType,
    isHovered
  } = props;
  let t0;
  if ($[0] !== toggleInputType) {
    t0 = toggleInputType?.selected?.value ? toggleInputType.selected.value?.replace(" ", "") : "";
    $[0] = toggleInputType;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const CTAComponentType = t0;
  const [iFrameVisibility, setiFrameVisibility] = useState(false);
  let t1;
  if ($[2] !== CTAComponentType || $[3] !== toggleInputType) {
    t1 = () => !!(CTAComponentType === "CTAButton" && toggleInputType?.ctaButton?.embedCode?.enabled && toggleInputType.ctaButton.embedCode?.value?.includes("<a "));
    $[2] = CTAComponentType;
    $[3] = toggleInputType;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const [isButtonEmbedded] = useState(t1);
  let finalCTAButton = null;
  if (CTAComponentType === "CTAButton" && toggleInputType.ctaButton) {
    if (toggleInputType.ctaButton.type && (toggleInputType.ctaButton.type === "Affirm" || toggleInputType.ctaButton.type === "Financing")) {
      let t2;
      if ($[5] !== imageProps.alt || $[6] !== imageProps.src) {
        t2 = <JBImage src={imageProps.src} alt={imageProps.alt} className="half-image" crop="focalpoint" fpY={0.7} sizes="(max-width: 767px) 100vw, 50vw" />;
        $[5] = imageProps.alt;
        $[6] = imageProps.src;
        $[7] = t2;
      } else {
        t2 = $[7];
      }
      let t3;
      if ($[8] !== isHovered || $[9] !== t2) {
        t3 = <FinancingCtaButton styling="simple-img-button" isHovered={isHovered}>{t2}</FinancingCtaButton>;
        $[8] = isHovered;
        $[9] = t2;
        $[10] = t3;
      } else {
        t3 = $[10];
      }
      finalCTAButton = t3;
    } else {
      let t2;
      if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = () => {
          setiFrameVisibility(true);
        };
        $[11] = t2;
      } else {
        t2 = $[11];
      }
      let t3;
      if ($[12] !== imageProps.alt || $[13] !== imageProps.src) {
        t3 = <JBImage src={imageProps.src} alt={imageProps.alt} className="half-image" crop="focalpoint" fpY={0.7} sizes="(max-width: 767px) 100vw, 50vw" />;
        $[12] = imageProps.alt;
        $[13] = imageProps.src;
        $[14] = t3;
      } else {
        t3 = $[14];
      }
      let t4;
      if ($[15] !== isHovered || $[16] !== t3) {
        t4 = <CtaButton onClick={t2} styling="simple-button" isHovered={isHovered}>{t3}</CtaButton>;
        $[15] = isHovered;
        $[16] = t3;
        $[17] = t4;
      } else {
        t4 = $[17];
      }
      finalCTAButton = t4;
    }
  }
  let t2;
  if ($[18] !== CTAComponentType || $[19] !== imageProps || $[20] !== toggleInputType) {
    t2 = CTAComponentType === "CTALink" && !!toggleInputType.ctaLink && <Link to={toggleInputType.ctaLink.linkTo}><JBImage src={imageProps.src} alt={imageProps.alt} className="half-image" crop="focalpoint" fpY={0.7} sizes="(max-width: 767px) 100vw, 50vw" /></Link>;
    $[18] = CTAComponentType;
    $[19] = imageProps;
    $[20] = toggleInputType;
    $[21] = t2;
  } else {
    t2 = $[21];
  }
  let t3;
  if ($[22] !== CTAComponentType || $[23] !== imageProps || $[24] !== toggleInputType?.ctaLink?.linkTo) {
    t3 = CTAComponentType === "CTALink" && !toggleInputType?.ctaLink?.linkTo && <JBImage src={imageProps.src} alt={imageProps.alt} className="half-image" crop="focalpoint" fpY={0.7} sizes="(max-width: 767px) 100vw, 50vw" />;
    $[22] = CTAComponentType;
    $[23] = imageProps;
    $[24] = toggleInputType?.ctaLink?.linkTo;
    $[25] = t3;
  } else {
    t3 = $[25];
  }
  let t4;
  if ($[26] !== CTAComponentType || $[27] !== finalCTAButton || $[28] !== iFrameVisibility || $[29] !== isButtonEmbedded || $[30] !== toggleInputType) {
    t4 = CTAComponentType === "CTAButton" && !!toggleInputType.ctaButton && toggleInputType.ctaButton.content && <div>{toggleInputType.ctaButton.embedCode.enabled && isButtonEmbedded && <div className="embed-button" dangerouslySetInnerHTML={{
        __html: toggleInputType.ctaButton.embedCode.value
      }} />}{toggleInputType.ctaButton.embedCode.enabled && !isButtonEmbedded && iFrameVisibility && <JBIFrameHolder isOpen={iFrameVisibility} onClose={setiFrameVisibility} script={toggleInputType.ctaButton.embedCode.value || ""} />}{!isButtonEmbedded && finalCTAButton}</div>;
    $[26] = CTAComponentType;
    $[27] = finalCTAButton;
    $[28] = iFrameVisibility;
    $[29] = isButtonEmbedded;
    $[30] = toggleInputType;
    $[31] = t4;
  } else {
    t4 = $[31];
  }
  let t5;
  if ($[32] !== t2 || $[33] !== t3 || $[34] !== t4) {
    t5 = <>{t2}{t3}{t4}</>;
    $[32] = t2;
    $[33] = t3;
    $[34] = t4;
    $[35] = t5;
  } else {
    t5 = $[35];
  }
  return t5;
};
ToggleCTAImageLink.propTypes = {
  toggleInputType: PropTypes.shape({
    ctaButton: PropTypes.shape({
      content: PropTypes.string,
      embedCode: PropTypes.shape({
        enabled: PropTypes.bool,
        value: PropTypes.string
      }),
      type: PropTypes.string,
      color: PropTypes.string,
      style: PropTypes.string
    }),
    ctaLink: PropTypes.shape({
      content: PropTypes.string,
      linkTo: PropTypes.string,
      color: PropTypes.string,
      style: PropTypes.string
    }),
    selected: PropTypes.shape({
      value: PropTypes.string
    })
  }),
  style: PropTypes.shape({
    height: PropTypes.string,
    width: PropTypes.string
  }),
  isHovered: PropTypes.bool,
  imageProps: PropTypes.shape({
    alt: PropTypes.string,
    sizes: PropTypes.string,
    src: PropTypes.string
  })
};
export default withRouter(ToggleCTAImageLink);